// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--33J3s"};